var map = {
	"./chinese.png": "86bc",
	"./english.png": "7b7f",
	"./french.png": "a7ac",
	"./german.png": "1aba",
	"./italian.png": "81ba",
	"./norwegian.png": "d9bf",
	"./portuguese.png": "0994",
	"./spanish.png": "a2aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0482";